import React, { createContext, useReducer, useState } from 'react'
import axios from '../../../../axios';
import useError from "../../../hooks/useError";


const createCampaign = () => {
    return {
        title: null,
        content: null,
        redirect_location: null,
        link_id: null,
        status: 1,
        images: [],
        files: [],
        expiration: null,
        background_color: "#ffffff",
        title_text_color: "#000000",
        home_page_active: false,
        campaign_type: "promotional"
    }
}

const CampaignsContext = createContext({
    campaign: createCampaign(),
    addCampaign: () => { },
    handleCampaign: () => { },
    handleCampaignImages: () => { },
    handleCampaignFiles: () => { },
    deleteCampaignFile: () => { },
    loadCampaign: () => { },
})


export const CampaignProvider = ({ children }) => {
    const [campaign, setCampaign] = useState(createCampaign());

    const { setError } = useError();


    const addCampaign = async () => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                }
            }

            for (let i = 0; i < campaign.images.length; i++) {
                if (typeof campaign.images[i] === 'string') {
                    campaign.images[i] = campaign.images[i];
                } else {
                    const formData = new FormData();
                    formData.append(
                        "product_image", campaign.images[i]
                    );

                }
            }


            delete campaign.files;

            if (campaign.id) {
                return await axios.post('/api/campaign/update_campaign', campaign, options);
            } else {
                return await axios.post('/api/campaign/add_campaign', campaign, options);
            }
        } catch (e) {
            return e;
        }
    }

    const handleCampaign = (updated) => {
        setCampaign(campaign => ({ ...campaign, ...updated }));
    }

    const handleCampaignImages = (image) => {
        let images = [...campaign.images, image];
        setCampaign(campaign => ({ ...campaign, images: images }));
    }

    const handleCampaignFiles = (file) => {
        let files = [...campaign?.files, file];
        setCampaign(campaign => ({ ...campaign, files: files }));
    }

    const deleteCampaignFile = (index) => {
        let files = campaign.files.filter((_, i) => i !== index);
        let images = campaign.images.filter((_, i) => i !== index);
        setCampaign(campaign => ({ ...campaign, files: files, images }));
    }




    const loadCampaign = async (id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                }
            }

            let res = await axios.get('/api/campaign/get_campaign/' + id, options);

            setCampaign({ ...res?.data?.campaign, files: res?.data?.campaign?.images })
        } catch (e) {
            setError({ title: 'No Campaign', message: 'No Campaign Exist, Or Error While Loading', status: 400 });
        }
    }

    return (
        <CampaignsContext.Provider
            value={{
                campaign,
                addCampaign,
                handleCampaign,
                handleCampaignImages,
                handleCampaignFiles,
                deleteCampaignFile,
                loadCampaign,
            }}
        >
            {children}
        </CampaignsContext.Provider>
    )
}

export default CampaignsContext
